import TabNavigation from './TabNavigation';

export { type TabNavigationProps } from './TabNavigation';
export default TabNavigation;
